import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
} from '@next/core-lib/dialog';

export interface SingleInputDialogModel extends AbstractFormDialogData {
  input: string;
}

@Component({
  selector: 'app-single-input-dialog',
  templateUrl: './single-input-dialog.component.html',
  styleUrls: ['./single-input-dialog.component.scss'],
  standalone: false,
})
export class SingleInputDialogComponent extends AbstractFormDialog<{
  input: string;
}> {
  data = inject<SingleInputDialogModel>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected mdDialogRef = inject<
    MatDialogRef<
      SingleInputDialogComponent,
      AbstractDialogResultData<{
        input: string;
      }>
    >
  >(MatDialogRef);

  formGroup = this.formBuilder.nonNullable.group({
    input: this.data.input,
  });
}
